var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketHalf = function SvgTicketHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h23v30H0z",
    "data-name": "Rectangle 25313"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "DESKTOP TICKET ICON"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v40H0z",
    "data-name": "Rectangle 25314"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 1228",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9938"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-15.438-5.5h40.874v40.874h-40.874Z",
    "data-name": "Path 5932"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc62d",
    d: "M22.03 11.531V4.718a3.405 3.405 0 0 0-3.406-3.406h-27.25a3.39 3.39 0 0 0-3.389 3.406v6.812a3.407 3.407 0 0 1-.017 6.813v6.812a3.416 3.416 0 0 0 3.406 3.406h27.25a3.416 3.416 0 0 0 3.406-3.406v-6.812a3.406 3.406 0 1 1 0-6.812m-3.406-2.487a6.8 6.8 0 0 0 0 11.785v4.326h-27.25v-4.326a6.84 6.84 0 0 0 3.406-5.893 6.8 6.8 0 0 0-3.389-5.893l-.017-4.325h27.25Zm-15.328 11h3.406v3.408H3.296Zm0-6.812h3.406v3.406H3.296Zm0-6.812h3.406v3.406H3.296Z",
    "data-name": "Path 5933"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "confirmation_number_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-15.438-5.5h40.874v40.874h-40.874Z",
    "data-name": "Path 5934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M3.296 20.046h3.406v3.406H3.296Zm0-6.812h3.406v3.406H3.296Zm0-6.812h3.406v3.406H3.296Z",
    "data-name": "Path 5935"
  })))))));
};
export { SvgTicketHalf as ReactComponent };
export default "/_next/static/images/ticket-half.svg";